import { createProjectPropertyResource } from '../../controllers/project-property-resource/index.tsx';

export const csmHubSetupSupportWebsiteResource = createProjectPropertyResource<Boolean>({
	propertyKey: 'csmHubSetup.supportWebsite',
	maxAge: 0,
});
